// Jayce — Mercury Hammer: in hammer form, every 2nd auto Jayce electrifies his
// target, dealing bonus physical damage and stunning for 1 turn.
// Transform to hammer form is handled by CombatEngine when Jayce becomes frontline.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const jayceMercuryHammer: Ability = {
  id: "jayceMercuryHammer",
  displayName: "Mercury Hammer",
  description: "In hammer form, every 2nd attack electrifies the target: 1.2× AD + 40 physical + 1-turn stun.",
  iconId: "JayceWMelee",

  targetShape({ caster, target }) {
    if (!caster.jayceHammerForm) return [];
    return [target.pos];
  },

  computeHits({ caster, target }): AbilityHit[] {
    if (!caster.jayceHammerForm) return [];
    if (caster.autoAttackCount % 2 !== 1) return [];
    const stats = effectiveStats(caster);
    return [{
      target,
      amount: physicalDamage(stats.ad * 1.2 + 40),
      type: "physical",
      effect: { kind: "stun", duration: 1 },
    }];
  },
};
